import { Success } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { Callout } from '../../../../Callout/Callout';
import { getParticipationInfo } from '../../../extras';
import type { LotteryName, Participation } from '../../../types';

type ParticipationExtraInfoProps = {
  lotteryName: LotteryName;
  participation: Participation;
  options?: string[];
  className?: string;
};

function ParticipationExtraInfo({ lotteryName, participation, options, className }: ParticipationExtraInfoProps) {
  const t = useTranslations('lotteries.ticket_details.your_numbers_section.extras');
  const info = getParticipationInfo(lotteryName, participation, options);

  if (!info) return null;

  return (
    <Callout variant="secondary" className={className}>
      {info.showIcon && <Success size="tiny" />}
      {t(info.translationKey)}
    </Callout>
  );
}

export { ParticipationExtraInfo };
